<template>
  <div class="asc-global-filter-confirmation">
    <div>
      Changing the selections in the Global Filter may affect any currently
      displayed plots and data in this session. If you wish to proceed, please
      select 'Continue.' Otherwise, please select 'Cancel'.
    </div>

    <asc-checkbox
      v-model="gafNotificationVisible"
      class="asc-checkbox"
      label="Do not show this message again."
      :checked="gafNotificationVisible"
      @change="handleUpdate(gafNotificationVisible)"
    />
  </div>
</template>

<script>
import AscCheckbox from '@/components/atoms/AscCheckbox'

export default {
  name: 'AscGlobalFilterConfirmation',

  components: {
    AscCheckbox,
  },

  props: {
    onUpdate: {
      type: Function,
      default: () => {},
    },
  },

  data() {
    return {
      gafNotificationVisible: false,
    }
  },

  methods: {
    handleUpdate(status) {
      if (this.onUpdate) {
        this.onUpdate(status)
      }
    },
  },
}
</script>

<style lang="scss">
.asc-global-filter-confirmation {
  .asc-checkbox {
    margin-top: 24px;
  }
}
</style>
